import { jsx as _jsx } from "react/jsx-runtime";
import { AreasTable } from '../components';
import { dictionary } from '../lang';
import { Layout } from '../layouts';
const Areas = () => (_jsx(Layout, { title: dictionary.VIEW_AREAS, children: _jsx(AreasTable, {}) }));
export default Areas;
